module.exports = __webpack_public_path__ + "static/media/dashboards.f47366d5.svg";